import Axios from "axios";
import config from "config";

Axios.defaults.timeout = 200000;

export const listCities = (state) => {
  if (!state) {
    return [];
  }
  const data = [
    {
      code: 3,
      city: [
        "",
        "اسكو",
        "اهر",
        "ایلخچی",
        "باسمنج",
        "بستان آباد",
        "بناب",
        "تبريز",
        "تسوج",
        "جلفا",
        "خسروشهر",
        "سراب",
        "سهند",
        "شبستر",
        "صوفیان",
        "مراغه",
        "مرند",
        "ملكان",
        "ممقان",
        "ميانه",
        "هاديشهر",
        "هريس",
        "هشترود",
        "ورزقان",
      ],
    },
    {
      code: 16,
      city: [
        "",
        "اروميه",
        "اشنويه",
        "بوكان",
        "تكاب",
        "خوي",
        "سر دشت",
        "سلماس",
        "شاهين دژ",
        "ماكو",
        "مهاباد",
        "مياندوآب",
        "نقده",
        "پلدشت",
        "پيرانشهر",
        "چالدران",
      ],
    },
    { code: 15, city: ["", "اردبيل", "خلخال", "مشگين شهر", "نمين", "نير", "پارس آباد", "گرمي"] },
    {
      code: 6,
      city: [
        "",
        "آران و بيدگل",
        "اردستان",
        "اصفهان",
        "باغ بهادران",
        "تودشک",
        "تيران",
        "حاجي آباد",
        "خميني شهر",
        "خوانسار",
        "درچه",
        "دهاقان",
        "زرين شهر",
        "سميرم",
        "شهرضا",
        "عسگران",
        "علويجه",
        "فلاورجان",
        "كاشان",
        "مباركه",
        "نجف آباد",
        "نطنز",
        "ورزنه",
        "کوهپایه",
        "گلپايگان",
      ],
    },
    { code: 27, city: ["", "آبدانان", "ايلام", "ايوان", "دره شهر", "دهلران", "سرابله", "مهران"] },
    {
      code: 21,
      city: [
        "",
        "اهرم",
        "برازجان",
        "بوشهر",
        "جم",
        "خورموج",
        "دير",
        "عسلویه",
        "كنگان",
        "کاکی",
        "گناوه",
      ],
    },
    {
      code: 1,
      city: [
        "",
        "اسلامشهر",
        "باقرشهر",
        "بومهن",
        "تجريش",
        "تهران",
        "دماوند",
        "رباط كريم",
        "رودهن",
        "ري",
        "شريف آباد",
        "شهريار",
        "فشم",
        "فيروزكوه",
        "قدس",
        "قرچك",
        "كهريزك",
        "لواسان",
        "ملارد",
        "ورامين",
        "پاكدشت",
        "چهاردانگه",
      ],
    },
    { code: 24, city: ["", "اردل", "بروجن", "شهركرد", "فارسان", "لردگان", "چلگرد"] },
    { code: 30, city: ["", "بيرجند", "سربيشه", "فردوس", "قائن", "نهبندان"] },
    {
      code: 7,
      city: [
        "",
        "تايباد",
        "تربت جام",
        "تربت حيدريه",
        "خواف",
        "درگز",
        "سبزوار",
        "سرخس",
        "طبس",
        "طرقبه",
        "فريمان",
        "قوچان",
        "كاشمر",
        "مشهد",
        "نيشابور",
        "چناران",
        "گناباد",
      ],
    },
    { code: 29, city: ["", "آشخانه", "اسفراين", "بجنورد", "جاجرم", "شيروان"] },
    {
      code: 4,
      city: [
        "",
        "آبادان",
        "انديمشك",
        "اهواز",
        "ايذه",
        "ايرانشهر",
        "باغ ملك",
        "بندر امام خميني",
        "بندر ماهشهر",
        "بهبهان",
        "حمیدیه",
        "خرمشهر",
        "دزفول",
        "رامشیر",
        "رامهرمز",
        "سوسنگرد",
        "شادگان",
        "شادگان",
        "شوش",
        "شوشتر",
        "لالي",
        "مسجد سليمان",
        "ملاثانی",
        "هنديجان",
        "هويزه",
      ],
    },
    { code: 12, city: ["", "آب بر", "ابهر", "خدابنده", "خرمدره", "زنجان", "قيدار", "ماهنشان"] },
    { code: 9, city: ["", "ايوانكي", "بسطام", "دامغان", "سمنان", "شاهرود", "گرمسار"] },
    {
      code: 26,
      city: ["", "ايرانشهر", "خاش", "زابل", "زاهدان", "سراوان", "سرباز", "ميرجاوه", "چابهار"],
    },
    {
      code: 5,
      city: [
        "",
        "آباده",
        "اردكان",
        "ارسنجان",
        "استهبان",
        "اقليد",
        "بوانات",
        "جهرم",
        "حاجي آباد",
        "خرامه",
        "خنج",
        "داراب",
        "زرقان",
        "سروستان",
        "سوريان",
        "سپيدان",
        "شيراز",
        "صفاشهر",
        "فراشبند",
        "فسا",
        "فيروز آباد",
        "كازرون",
        "لار",
        "لامرد",
        "مرودشت",
        "مهر",
        "کوار",
      ],
    },
    { code: 8, city: ["", "آبيك", "بوئين زهرا", "تاكستان", "قزوين"] },
    { code: 10, city: ["", "قم"] },
    { code: 31, city: ["", "اشتهارد", "طالقان", "كرج", "ماهدشت", "نظرآباد", "هشتگرد"] },
    {
      code: 18,
      city: ["", "بانه", "بيجار", "حسن آباد", "سقز", "سنندج", "صلوات آباد", "قروه", "مريوان"],
    },
    {
      code: 22,
      city: [
        "",
        "انار",
        "بافت",
        "بردسير",
        "بم",
        "جيرفت",
        "راور",
        "رفسنجان",
        "زرند",
        "سيرجان",
        "كرمان",
        "كهنوج",
        "کوهبنان",
      ],
    },
    {
      code: 19,
      city: [
        "",
        "اسلام آباد غرب",
        "جوانرود",
        "سنقر",
        "صحنه",
        "قصر شيرين",
        "كرمانشاه",
        "كنگاور",
        "هرسين",
        "پاوه",
      ],
    },
    { code: 28, city: ["", "دهدشت", "دوگنبدان", "سي سخت", "ياسوج", "گچساران"] },
    {
      code: 14,
      city: [
        "",
        "آزاد شهر",
        "آق قلا",
        "راميان",
        "علي آباد كتول",
        "كردكوی",
        "كلاله",
        "گرگان",
        "گنبد كاووس",
      ],
    },
    {
      code: 2,
      city: [
        "",
        "آستارا",
        "املش",
        "تالش",
        "رشت",
        "رودبار",
        "شفت",
        "صومعه سرا",
        "فومن",
        "لاهیجان",
        "لنگرود",
        "ماسال",
        "ماسوله",
        "منجيل",
        "هشتپر",
      ],
    },
    {
      code: 20,
      city: [
        "",
        "ازنا",
        "الشتر",
        "اليگودرز",
        "بروجرد",
        "خرم آباد",
        "دزفول",
        "دورود",
        "كوهدشت",
        "ماهشهر",
        "نور آباد",
      ],
    },
    {
      code: 13,
      city: [
        "",
        "آمل",
        "بابل",
        "بابلسر",
        "بلده",
        "بهشهر",
        "تنكابن",
        "جويبار",
        "رامسر",
        "ساري",
        "قائم شهر",
        "محمود آباد",
        "نكا",
        "نور",
        "نوشهر",
        "چالوس",
      ],
    },
    { code: 11, city: ["", "آشتيان", "اراك", "تفرش", "خمين", "دليجان", "ساوه", "شازند", "محلات"] },
    {
      code: 23,
      city: [
        "",
        "بستك",
        "بندر جاسك",
        "بندر خمیر",
        "بندر لنگه",
        "بندرعباس",
        "حاجي آباد",
        "دهبارز",
        "قشم",
        "قشم",
        "كيش",
        "ميناب",
      ],
    },
    { code: 17, city: ["", "اسدآباد", "بهار", "رزن", "ملاير", "نهاوند", "همدان"] },
    {
      code: 25,
      city: [
        "",
        "ابركوه",
        "اردكان",
        "اشكذر",
        "بافق",
        "تفت",
        "خضرآباد",
        "زارچ",
        "طبس",
        "مهريز",
        "ميبد",
        "هرات",
        "يزد",
      ],
    },
  ];

  const xx = data.filter((a) => `${a.code}` === `${state}`);

  return xx[0].city;
};

export const getDashboard = async (token) => {
  try {
    const url = `${config.apiserver}/order/getdashboard/`;
    const res = await Axios.post(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getUniversitiesReg = async () => {
  try {
    const url = `${config.apiserver}/app/universities/`;
    const res = await Axios.get(url);
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const storeUniversity = async (newUniversity, token) => {
  try {
    const url = `${config.apiserver}/admin/university/`;
    const res = await Axios.post(url, newUniversity, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getUniversities = async (search, token) => {
  try {
    const url = `${config.apiserver}/admin/universities/${search}`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getUniversity = async (id, token) => {
  try {
    const url = `${config.apiserver}/admin/University/${id}`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const updateUniversity = async (editedUniversity, token) => {
  const url = `${config.apiserver}/admin/university/`;

  const data = await Axios.put(url, editedUniversity, {
    headers: {
      "x-access-token": token,
    },
  });

  return data.data;
};
export const deleteUniversity = async (id, token) => {
  try {
    const url = `${config.apiserver}/admin/university/${id}`;
    const responce = await Axios.delete(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getClinicsCount = async () => {
  try {
    const url = `${config.apiserver}/app/clinicscount/`;
    const res = await Axios.get(url);
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getClinicsReg = async (university) => {
  try {
    const url = `${config.apiserver}/app/clinics/${university}`;
    const res = await Axios.get(url);
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getClinics = async (university, search, token) => {
  try {
    const url = `${config.apiserver}/admin/clinics/${university}/${search}`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const storeClinic = async (newData, token) => {
  try {
    const url = `${config.apiserver}/admin/clinic/`;
    const res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
      message: "خطایی رخ داده است",
    };
    return data;
  }
};
export const updateClinic = async (newData, token) => {
  const url = `${config.apiserver}/admin/clinic/`;

  const data = await Axios.put(url, newData, {
    headers: {
      "x-access-token": token,
    },
  });

  return data.data;
};

export const getClinic = async (id, token) => {
  try {
    const url = `${config.apiserver}/admin/clinic/${id}`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
      message: "خطایی رخ داده است",
    };
    return data;
  }
};
export const deleteClinic = async (id, token) => {
  try {
    const url = `${config.apiserver}/admin/clinic/${id}`;
    const responce = await Axios.delete(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const getClinicsUser = async (user, token) => {
  try {
    const url = `${config.apiserver}/admin/getuserclinics/${user}`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const getCities = async (lang, token) => {
  try {
    const url = `${config.apiserver}/admin/getcities/${lang}`;

    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const getSMSCount = async (token) => {
  try {
    const url = `${config.apiserver}/admin/countersms/`;
    const res = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
